/**
 * A custom element that counts down to a target date/time and swaps to an
 * "expired" state once the target has passed.
 */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.targetDate = new Date(this.dataset.target);
    this.digitsEl = this.querySelector('[data-countdown-digits]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');

    if (isNaN(this.targetDate.getTime())) {
      return;
    }

    this.#tick();
    this.interval = setInterval(this.#tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  #tick = () => {
    const remaining = this.targetDate.getTime() - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.digitsEl?.setAttribute('hidden', '');
      this.expiredEl?.removeAttribute('hidden');
      return;
    }

    const seconds = Math.floor(remaining / 1000) % 60;
    const minutes = Math.floor(remaining / (1000 * 60)) % 60;
    const hours = Math.floor(remaining / (1000 * 60 * 60)) % 24;
    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));

    this.#setUnit('days', days);
    this.#setUnit('hours', hours);
    this.#setUnit('minutes', minutes);
    this.#setUnit('seconds', seconds);
  };

  #setUnit(unit, value) {
    const el = this.querySelector(`[data-unit="${unit}"]`);
    if (el) el.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
